import React from "react";
import Card from "react-bootstrap/Card";

function ExperienceCard({ role, company, duration, description }) {
  return (
    <Card className="project-card-view">
      <Card.Body>
        <Card.Title style={{ fontWeight: "bold" }}>{role}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">{company}</Card.Subtitle>
        <Card.Text style={{ textAlign: "justify" }}>
          <strong className="purple">Duration: </strong>{duration}
          <br />
          <br />
          {description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default ExperienceCard;
